import { render, staticRenderFns } from "./attendanceDevices.vue?vue&type=template&id=996f73fe&scoped=true&"
import script from "./attendanceDevices.vue?vue&type=script&lang=js&"
export * from "./attendanceDevices.vue?vue&type=script&lang=js&"
import style0 from "./attendanceDevices.vue?vue&type=style&index=0&id=996f73fe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "996f73fe",
  null
  
)

component.options.__file = "attendanceDevices.vue"
export default component.exports